import { render, staticRenderFns } from "./widget-editor-publication-status.vue?vue&type=template&id=439c2f8c&scoped=true&"
import script from "./widget-editor-publication-status.vue?vue&type=script&lang=js&"
export * from "./widget-editor-publication-status.vue?vue&type=script&lang=js&"
import style0 from "./widget-editor-publication-status.vue?vue&type=style&index=0&id=439c2f8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439c2f8c",
  null
  
)

export default component.exports